// extracted by mini-css-extract-plugin
module.exports = {"sm":"_1f5a010","md":"_a97f510","lg":"_0a37de9"};